;(function ( $ ) {

    /**
     *  ticketData
     *  populate form and text-fields with data from form overlay
     **/

    'use strict';

    // Create the defaults once
    var pluginName = 'ticketData';
    var defaults = {};

    // The actual plugin constructor
    function Plugin ( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {
        init: function () {
            this.registerEvents();
        },

        registerEvents: function() {
            var _this = this;
            $(window).on('ticketdata.set', function(e, data) {
                data = _this.formArrayToObject(data);
                _this.updateTicketPreview(data);

                console.log(e, data);
            });
            $(this.element).find('.next-ticket-link').on('click', function(e) {
                e.preventDefault();
                $(window).trigger('ticket-slides.next');
            });
            $(this.element).find('.prev-ticket-link').on('click', function(e) {
                e.preventDefault();
                $(window).trigger('ticket-slides.prev');
            });
        },

        updateTicketPreview: function(data) {
            var $ticket = $('#li-ticket-' + data.index );
            $ticket.find('#ticket-' + data.index + '-salutation').val(data.salutation);
            $ticket.find('.ticket-preview-body .title').text(data.title);
            $ticket.find('.ticket-preview-body .givenname').text(data.givenname);
            $ticket.find('#ticket-' + data.index + '-title').val(data.title);
            $ticket.find('#ticket-' + data.index + '-givenname').val(data.givenname);
            $ticket.find('.ticket-preview-body .surname').text(data.surname);
            $ticket.find('#ticket-' + data.index + '-surname').val(data.surname);
            $ticket.find('.ticket-preview-body .company').text(data.company);
            $ticket.find('#ticket-' + data.index + '-company').val(data.company);
            $ticket.find('.ticket-preview-body .country').text(data.country);
            $ticket.find('#ticket-' + data.index + '-country').val(data.country);
            $ticket.find('.ticket-preview-body .country').text(data.country);
            $ticket.find('#ticket-' + data.index + '-country').val(data.country);
            $ticket.find('#ticket-' + data.index + '-email').val(data.email);
            $ticket.find('.ticket-recipient').show();

			$ticket.addClass('ticket-completed');
        },

        formArrayToObject: function(data) {
            var retVal = {};
            for ( var i = 0; i < data.length; i++) {
                retVal[data[i].name] = data[i].value;
            }
            return retVal;
        }
    });

    $.fn[ pluginName ] = function ( options ) {
        return this.each(function() {
            if ( !$.data( this, 'plugin_' + pluginName ) ) {
                $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
            }
        });
    };
})( jQuery );
